/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Header from "../../components/Header/Header.jsx";
import Footer from "../../components/Footer/Footer.jsx";
import Sidebar from "../../components/Sidebar/Sidebar.jsx";
import { dashboardRoutes } from "../../routes/dashboard.jsx";
import dashboardStyle from "../../assets/jss/material-dashboard-react/layouts/dashboardStyle.jsx";
import image from "../../assets/img/sidebar-2.jpg";
import logo from "../../assets/img/reactlogo.png"
import { Container } from "reactstrap";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
const switchRoutes = (
  <Switch>
    {dashboardRoutes.map((prop, key) => {
      if (prop.redirect)
        return <Redirect from={prop.path} to={prop.to} key={key} />;
      return <Route path={prop.path} component={prop.component} key={key} />;
    })}
  </Switch>
);

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false
    };
    this.resizeFunction = this.resizeFunction.bind(this);
    this.refMainPanel = React.createRef();
    this.setSidebarRef = this.setSidebarRef.bind(this);
  }
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return this.props.location.pathname !== "/maps";
  }

  setSidebarRef(element) {
    this.sidebarRef = element;
    let ps = null;
    if (navigator.platform.indexOf("Win") > -1 && element) {
      ps = new PerfectScrollbar(element, {
        suppressScrollX: true,
        suppressScrollY: false
      });
    }
  }
  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }
  componentDidMount() {
    //if (navigator.platform.indexOf("Win") > -1) {
    //   const ps = PerfectScrollbar(this.refMainPanel.current);
    //}
    window.addEventListener("resize", this.resizeFunction);
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      //this.refMainPanel.current.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }
  componentWillUnmount() {
    //if (ps!==undefined) {
    //  if (navigator.platform.indexOf("Win") > -1 && ps) {
    //  ps.destroy();
    //  }
    // }
    window.removeEventListener("resize", this.resizeFunction);
  }
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div className={classes.wrapper}>

        <Sidebar
          routes={dashboardRoutes}
          logoText={"CalBit Portal"}
          logo={logo}
          image={image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="blue"
          {...rest}
        />
        <div className={classes.mainPanel} ref={this.setSidebarRef}
        >
          <Header
            routes={dashboardRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />
          {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {this.getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>{switchRoutes}</div>
            </div>
          ) : (
              <div className={classes.map}>{switchRoutes}</div>
            )}
          {this.getRoute() ? <Footer /> : null}
        </div>
      </div>
      // <Container style={{width:'100%',margin:0,marginTop:-100,paddingRight:0}}>
      //   {/* <Sidebar
      //     routes={dashboardRoutes}
      //     logoText={"CalBit Portal"}
      //     logo={logo}
      //     image={image}
      //     handleDrawerToggle={this.handleDrawerToggle}
      //     open={this.state.mobileOpen}Container
      //     color="blue"
      //     {...rest}
      //   /> */}
      //   <div ref="mainPanel">
      //     {/* <Header
      //       routes={dashboardRoutes}
      //       handleDrawerToggle={this.handleDrawerToggle}
      //       {...rest}
      //     /> */}
      //     {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
      //     {this.getRoute() ? (
      //       <div className={classes.content}>
      //         <div className={classes.container}>{switchRoutes}</div>
      //       </div>
      //     ) : (
      //       <div className={classes.map}>{switchRoutes}</div>
      //     )}
      //     {/* {this.getRoute() ? <Footer /> : null} */}
      //   </div>
      // </Container>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(App);


// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx